import React, { useEffect, useState, useCallback } from 'react';
import Layout from '../reporting_utils/Layout';
import useFiltersState from '../reporting_utils/useFiltersState';
import { getFilterValues } from '../reporting_utils/misc';
import { Common } from '../../utils/common';
import moment from 'moment';
import DataTable from '../reporting_utils/DataTable';

const pageLoadingFrame = window.pageLoadingFrame;

const defaultFilterState = {};

export default function BookNowDetails() {
  const [tableData, setTableData] = useState([]);
  const [filters, setFilters] = useFiltersState(defaultFilterState);

  const fetchTableData = useCallback(async () => {
    if (!filters.domains) {
      return;
    }
    pageLoadingFrame('show');
    try {
      const res = await fetch('/book_now_details', {
        headers: {
          'X-CSRF-Token': document.querySelector('meta[name=csrf-token]').content,
          'Content-Type': 'application/json',
        },
        method: 'POST',
        body: JSON.stringify(getFilterValues(filters)),
      });
      const data = await res.json();
      setTableData(data.tableData);
    } catch (error) {
      console.error(error);
      Common.notify('Failed to fetch report data', 'error');
    } finally {
      pageLoadingFrame('hide');
    }
  }, [filters]);

  useEffect(() => {
    fetchTableData();
  }, [fetchTableData]);

  return (
    <Layout
      title='Book Now Details'
      fetchData={fetchTableData}
      filters={filters}
      setFilters={setFilters}
      defaultFilterState={defaultFilterState}
    >
      <DataTable
        data={tableData}
        columnDefs={columnDefs}
        title='Book Now Details'
        showCounterColumn={true}
      />
    </Layout>
  );
}

const columnDefs = [
  { data: 'location_name', title: 'Location Name' },
  { data: 'name', title: 'Name', visible: false },
  { data: 'street', title: 'Street', visible: false },
  { data: 'city', title: 'City', visible: false },
  { data: 'state', title: 'State', visible: false },
  { data: 'zip', title: 'Zip', visible: false },
  {
    data: 'cell_number',
    title: 'Cell Number',
    visible: false,
    render(data) {
      return Common.formatPhoneNumber(data);
    },
  },
  {
    data: 'requested_appt_date',
    title: 'Appointment Date',
    render(data) {
      if (data) {
        return moment(data).format('MMM D, YYYY');
      } else {
        return null;
      }
    },
  },
  {
    data: 'created_at',
    title: 'Created At',
    render(data) {
      if (data) {
        return moment.utc(data).local().format('MMM D, YYYY h:mm A');
      } else {
        return null;
      }
    },
  },
  { data: 'external_unit_name', title: 'Buiness Unit', visible: false },
  { data: 'business_unit_alias', title: 'Business Unit Alias' },
  { data: 'business_unit_category_alias', title: 'Business Unit Category Alias' },
  { data: 'external_job_type_name', title: 'Job Type', visible: false },
  { data: 'job_type_alias', title: 'Job Type Alias' },
  { data: 'appointment_name', title: 'Appointment Name' },
  {
    data: 'start_time',
    title: 'Start Time',
    render(data) {
      if (data) {
        return moment(data, 'HHmm').format('h:mm A');
      } else {
        return null;
      }
    },
  },
  {
    data: 'end_time',
    title: 'End Time',
    render(data) {
      if (data) {
        return moment(data, 'HHmm').format('h:mm A');
      } else {
        return null;
      }
    },
  },
  { data: 'landing_url', title: 'Landing Url', visible: false },
  { data: 'orig_url', title: 'Original Url', visible: false },
  { data: 'utm_campaign', title: 'Utm Campaign', visible: false },
  { data: 'utm_medium', title: 'Utm Medium', visible: false },
  { data: 'utm_source', title: 'Utm Source', visible: false },
  { data: 'utm_content', title: 'Utm Content', visible: false },
  { data: 'utm_term', title: 'Utm Term', visible: false },
  { data: 'gclid', title: 'GCLID', visible: false },
  { data: 'ref_domain', title: 'Ref Domain', visible: false },
  { data: 'ref_medium', title: 'Ref Medium', visible: false },
  { data: 'ref_type', title: 'Ref Type', visible: false },
];
